// De tekst op een hectometerpaaltje in de geanimeerde voortgangsbalk: hoe ver
// díé plek langs de route ligt, en hoe lang de route is.
//
// Het paaltje staat op een vaste plek en is GEEN teller: bij vraag 1 kan het
// paaltje van '2 / 3' al in beeld staan. Rob las het als 'ik ben bij 2 van 3'
// (testronde 2026-10-15, B7). De teller staat daarom apart in de lucht
// (`stepLabel` in ImmersiveProgressBar).

/**
 * @param {number} km - De afstand die het paaltje markeert
 * @param {number} total - De lengte van de route (het aantal stappen)
 * @returns {string} Bijvoorbeeld '2 / 3 km'
 */
const hectometerLabel = (km, total) => `${km} / ${total} km`;

export default hectometerLabel;
